import { differenceInCalendarMonths, parseISO } from 'date-fns'
import type { CarStatus } from '../../../../../types'
import Pill, { type PillColor } from '../_shared/Pill'
import HoverBox from '../_shared/HoverBox'
import formatNumber from './formatNumber'
import { WarningTriangle } from '../icons'
import { formatDate } from './formatDate'

export const formatStatus = (status) => {
  if (!status) return '-'
  const statusMeta: Record<CarStatus, { color: PillColor; label: string }> = {
    active: { color: 'green', label: 'Aktiv' },
    administrated: { color: 'blue', label: 'Administrert' },
    order: { color: 'orange', label: 'I bestilling' },
    closed: { color: 'purple', label: 'Avsluttet' },
  }
  const { color, label } = statusMeta[status] ?? {
    color: 'neutral' as PillColor,
    label: String(status),
  }
  return <Pill color={color}>{label}</Pill>
}

export const formatLeaseTerm = (actualDeliveryDate, plannedReturnDate) => {
  const start = parseISO(actualDeliveryDate)
  const end = parseISO(plannedReturnDate)
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return '-'
  const lifetime = differenceInCalendarMonths(end, start)
  const currentLife = differenceInCalendarMonths(new Date(), start)
  return `${currentLife}/${lifetime}`
}

export const formatSimulatedMileage = (simulatedMileage, contractMileage) => {
  if (!simulatedMileage) {
    return '-'
  }
  if (simulatedMileage > contractMileage) {
    return (
      <HoverBox
        trigger={
          <span className="flex">
            {`${formatNumber(simulatedMileage)} km`}
            <span className="text-old-content-danger">
              <WarningTriangle />
            </span>
          </span>
        }
        content={<span>Simulert antall km viser tendens til å overstige maks km.</span>}
      />
    )
  }
  return `${formatNumber(simulatedMileage)} km`
}

export const formatNextInspectionDate = (nextInspectionDate) => {
  if (!nextInspectionDate) return '-'
  const formattedDate = formatDate(nextInspectionDate)
  const date = new Date(nextInspectionDate)
  const now = new Date()
  const diffDays = (date.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
  return (
    <div className="flex items-center">
      <span>{formattedDate}</span>
      {diffDays < 0 && <div className="w-4 h-4 rounded-full bg-old-content-danger ml-1" />}
      {diffDays >= 0 && diffDays <= 60 && <div className="w-4 h-4 rounded-full bg-old-warning ml-1" />}
    </div>
  )
}
